import { UserRolesModel } from '../../../../accounts/models/UserRolesInfo';
import { WarehouseModel } from '../../../../products/models/WarehouseModel';
import WarehouseView from '../../../../products/views/WarehouseView';
import { OrderModel } from '../../../models/OrderModel';
import { OrderUtils } from '../../shared/OrderUtils';

type ChangeOrderWarehouseProps = {
    order: OrderModel;
    userRoles: UserRolesModel;
    loading: boolean;
    showWarehouseList: boolean;
    setShowWarehouseList: (value: boolean) => void;
    onUnassign: () => void;
    onAssign: (newWarehouse: WarehouseModel) => void;
}

export default function ChangeOrderWarehouseView({
    order, userRoles, loading, showWarehouseList, setShowWarehouseList,
    onAssign, onUnassign
}: ChangeOrderWarehouseProps) {
    return <>
        <div className="pb-10" style={{ fontWeight: "bold" }}>Warehouse</div>
        <div className="fl-grid">
            <div className="fl-span7">{order.warehouse.name}</div>
            <div className="fl-span5 right">
                {OrderUtils.isPendingStatus(order.status) && <>
                    <a href="#" onClick={() => setShowWarehouseList(true)}>Change</a>
                    <span className="ph-5">|</span>
                    <a href="#" onClick={onUnassign}>Unassign</a>
                </>}
            </div>
        </div>

        {showWarehouseList && <>
            <WarehouseView
                onSelect={onAssign}
                onClose={() => setShowWarehouseList(false)}
            />
        </>}
    </>;
}